import { useGetChallengeDetails } from "@/layout/ChallengeSubmissionWrapper/hooks/useGetChallengeDetails";
import { UserChallengeStatus } from "@/services/challenges/types/challenges.enums";
import Theme from "@/utils/theme";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

export const useQuizChallengeSubmission = () => {
  const { id } = useParams();
  const { data: challenge } = useGetChallengeDetails({
    type: "quiz",
    id: Number(id),
  });

  const [isOpenQuiz, setIsOpenQuiz] = useState(false);
  const toggleQuiz = () => setIsOpenQuiz(!isOpenQuiz);

  const challengeStatus = useMemo(() => {
    if (challenge?.status === UserChallengeStatus.FINISHED) {
      return {
        color: Theme.colors.feedback.positive,
        text: "Concluído",
      };
    }

    if (challenge?.status === UserChallengeStatus.REJECTED) {
      return {
        color: Theme.colors.feedback.negative,
        text: "Reprovado",
      };
    }

    return {
      color: Theme.colors.feedback.warning,
      text: "Pendente",
    };
  }, [challenge?.status]);

  const quizStatus = useMemo(() => {
    if (challenge?.status === UserChallengeStatus.FINISHED) {
      return {
        color: Theme.colors.feedback.positive,
        text: "Concluído",
      };
    }

    return {
      color: Theme.colors.feedback.warning,
      text: "Pendente",
    };
  }, [challenge?.status]);

  return {
    challenge,
    challengeStatus,
    quizStatus,

    toggleQuiz,
    isOpenQuiz,
  };
};
